import {DataTableProps} from "./DataTable";
import {useEffect, useState} from "react";
import {firstOrUndefined} from "@ots-frontend/ots-data";
import {DataTablePaginationProps} from "mantine-datatable/dist/types/DataTablePaginationProps";

export type UsePaginationResult<T> = Pick<DataTableProps<T>, "records"> & DataTablePaginationProps

export type UsePaginationProps<T> = Pick<DataTableProps<T>, 'recordsPerPageOptions'> & {
  data?: T[],
  defaultPageSize?: number,
}

export const PAGINATION_PAGE_SIZES = [25, 50, 75, 100];

export function usePagination<T>(props: UsePaginationProps<T>): UsePaginationResult<T> | {  records: T[] } {
  const {data, recordsPerPageOptions, defaultPageSize = firstOrUndefined(recordsPerPageOptions)} = props;

  const [pageSize, setPageSize] = useState<number>(defaultPageSize ?? (recordsPerPageOptions ? recordsPerPageOptions[0] : PAGINATION_PAGE_SIZES[0]));
  const [page, setPage] = useState<number>(1);
  const [records, setRecords] = useState<T[]>([]);

  useEffect(() => {
    setPage(1)
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (recordsPerPageOptions && pageSize) {
      const from = (page - 1) * pageSize;
      const to = from + pageSize;
      setRecords(data?.slice(from, to) ?? []);
    } else {
      setRecords(data ?? [])
    }
  }, [JSON.stringify(data), recordsPerPageOptions, page, pageSize]);

  if (recordsPerPageOptions) {
    return {
      page: page,
      records: records,
      recordsPerPage: pageSize,
      recordsPerPageOptions: recordsPerPageOptions,
      onPageChange: (p) => setPage(p),
      onRecordsPerPageChange: setPageSize,
      totalRecords: data.length
    }
  } else {
    return {
      records: records,
    }
  }
}
